// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const METADATA = {
    "tag": "sd-8.6.2"
};
/* tslint:enable */
